export default "__VITE_ASSET__BMvbHTi8__"